import { toSnakeCaseStringUtil } from 'packages/src'

function getActionStrReduxUtil (action, ...keys) {
  if (!keys || !keys.length) {
    return action
  }
  return `${action.toUpperCase()}_${keys.map(key => toSnakeCaseStringUtil(key + '')
    .toUpperCase())
    .join('_')}`
}

export { getActionStrReduxUtil }
